<template>
  <OmtLayoutHeaderFooter
    bg="#F6F6F9"
    :footer="false"
    :header="{ titleLabel: 'Insights de Saúde' }"
  >
    <router-view />
  </OmtLayoutHeaderFooter>
</template>

<script>
export default {
  name: "InsightsSaudeIndex",
  mounted() {
    // O loader fica a cargo de cada tela filha: o mounted do pai roda depois do da filha e
    // desligaria o loader que ela acabou de ligar.
    this.$root.$emit("show-back-button");
  }
};
</script>
